import { render, staticRenderFns } from "./VaimoMobileMenu.vue?vue&type=template&id=6823a858&scoped=true&"
import script from "./VaimoMobileMenu.vue?vue&type=script&lang=ts&"
export * from "./VaimoMobileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoMobileMenu.vue?vue&type=style&index=0&id=6823a858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823a858",
  null
  
)

export default component.exports